import React, { useState, useEffect } from 'react';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';
import i18n from '../../translate/i18n';
import '../../components/styles/MainForm.css';
import OnlineForm from '../../components/OnlineForm/OnlineForm';
import OnlineFormPage2 from '../../components/OnlineForm/OnlineFormPage2';
import OnlineFormPage3 from '../../components/OnlineForm/OnlineFormPage3';
import PreviewPage from '../../components/OnlineForm/PreviewPage';
import CardGeneration from '../../components/CardGeneration/CardGenerator';
import FormThanks from '../../components/CardGeneration/FormThanks';
import AdvertiseChromeModal from './AdvertiseChromeModal';
import { BrowserView, MobileView, isChrome, isEdge, isSafari, isFirefox, isIE } from 'react-device-detect';

const MainForm = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    lastName: '',
    dateOfBirth: '',
    bloodGroup: '',
    preferredHand: '',
    phones: [''],
    country: '',
    identityDocument: '',
    healthServiceProvider: '',
    emergencyMedicalService: '',
    conditions: [{ diseaseName: '', medication: { medicationName: '', dosage: '', frequency: '' }}],
    commentary: '',
    promotionalCode: '',
    date: ''
  });
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const browser = getBrowser();
    if (browser !== 'Chrome') {
      setIsModalOpen(true);
    }
  }, []);

  const [language, setLanguage] = useState('es');
  const [previewVisible, setPreviewVisible] = useState(false);

  const getBrowser = () => {
    if (isChrome) {
      return 'Chrome';
    } else if (isEdge) {
      return 'Edge';
    } else if (isSafari) {
      return 'Safari';
    } else if (isFirefox) {
      return 'Firefox';
    } else if (isIE) {
      return 'Internet Explorer';
    } else {
      return 'Unknown';
    }
  };

  const handleLanguageChange = (newLanguage) => {
    i18n.changeLanguage(newLanguage);
    setLanguage(newLanguage);
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleShowPreview = () => {
    setCurrentPage('preview');
  };

  const handleCardGenerator = () => {
    setCurrentPage('generate');
  }

  const handleThanks = () => {
    setCurrentPage('thanks');
  }

  const handleClosePreview = () => {
    setCurrentPage(3);
    setPreviewVisible(false);
  };

  return (
    // <div style={{display: 'flex', flexDirection: 'column'}}>
    <>
      <LanguageSelector onChangeLanguage={handleLanguageChange} />
      {getBrowser() !== 'Chrome' && (
        <AdvertiseChromeModal isModalOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} />
      )}
      {/* <AdvertiseChromeModal isModalOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} /> */}
      {currentPage === 1 && (
        <>
          <OnlineForm
            language={language} 
            formData={formData} 
            setFormData={setFormData} 
            onNextPage={handleNextPage} 
          />
        </>
      )}
      {currentPage === 2 && (
        <>
          <OnlineFormPage2
            language={language} 
            formData={formData} 
            setFormData={setFormData} 
            onNextPage={handleNextPage} 
            onPrevPage={handlePrevPage} 
          />
        </>
      )}
      {currentPage === 3 && (
        <>
          <OnlineFormPage3
            language={language} 
            formData={formData} 
            setFormData={setFormData} 
            onNextPage={handleShowPreview} 
            onPrevPage={handlePrevPage} 
          />
        </>
      )}
      {currentPage === 'preview' && (
        <PreviewPage 
          formData={formData} 
          language={language} 
          onClose={handleClosePreview}
          onNextPage={handleCardGenerator} 
        />
      )}
      {currentPage === 'generate' && (
        <>
        <CardGeneration
          language={language} 
          formData={formData}
          onClose={handleShowPreview}
          onNextPage={handleThanks}
        />
        </>
      )}
      {
        currentPage === 'thanks' && (
          <>
            <FormThanks
              language={language}
              onClose={handleCardGenerator}
            />
          </>
        )
      }
    {/* </div> */}
    </>
  );
};

export default MainForm;
